import React from "react";
import { Link } from "react-router-dom";
import poloImage from '../image/polologo.jpeg';

function History() {
  return (
    <div className="w-full bg-slate-50/50 font-sans overflow-hidden">

      {/* Premium Hero Section */}
      <div className="relative w-full bg-gradient-to-r from-orange-500 via-amber-500 to-orange-600 pt-20 pb-28 md:pt-24 md:pb-36 lg:pt-28 lg:pb-40 px-6 overflow-hidden">

        {/* Ambient Radial Glow Effect */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/10 rounded-full blur-3xl pointer-events-none"></div>

        <div className="max-w-4xl mx-auto text-center text-white space-y-4 relative z-10">
          <div className="inline-flex items-center gap-2 px-3.5 py-1 rounded-full bg-white/10 backdrop-blur-md border border-white/20 mb-2 shadow-sm">
            <span className="w-2 h-2 rounded-full bg-white animate-pulse"></span>
            <span className="text-xs font-bold uppercase tracking-wider text-orange-50">Our Journey</span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-6xl font-black tracking-tight drop-shadow-md">
            Our Heritage & History
          </h1>
          <p className="text-sm sm:text-base md:text-lg font-normal leading-relaxed text-orange-50 opacity-95 max-w-2xl mx-auto">
            In a world where water is a vital lifeline, PoloPipes steps in as a trusted fluid network manufacturer committed to durability, efficiency, and engineering excellence.
          </p>
        </div>

        {/* Clean Solid White Curved SVG Divider */}
        <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-[0] z-10">
          <svg
            className="relative block w-full h-[60px] md:h-[100px]"
            viewBox="0 0 1920 120"
            preserveAspectRatio="none"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0,120 C640,30 1280,30 1920,120 L1920,120 L0,120 Z"
              fill="#ffffff"
            />
          </svg>
        </div>
      </div>

      {/* Breadcrumb Navigation Bar */}
      <div className="bg-white py-3.5 px-6 sm:px-12 border-b border-slate-100 relative z-20">
        <div className="max-w-7xl mx-auto flex items-center space-x-2 text-xs sm:text-sm font-medium text-slate-500">
          <Link to="/" className="text-orange-600 hover:text-orange-700 font-semibold transition-colors">Home</Link>
          <span className="text-slate-300 font-light">&gt;</span>
          <span className="text-slate-800">History</span>
        </div>
      </div>

      {/* Core History Content */}
      <section className="py-16 md:py-24 bg-white relative">
        <div className="flex flex-col px-6 md:px-12 mx-auto space-y-12 max-w-7xl">

          {/* Section Header */}
          <div className="text-center space-y-2">
            <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold tracking-wider uppercase bg-orange-100 text-orange-700">
              Our Heritage
            </span>
            <h2 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight">
              Building Trust Through Quality Since 2007
            </h2>
          </div>

          <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">

            {/* Sticky Image Container */}
            <div className="w-full lg:w-5/12 order-first lg:order-last lg:sticky lg:top-24">
              <div className="overflow-hidden rounded-3xl shadow-xl border border-slate-200/80 bg-slate-50 p-2.5">
                <img
                  className="w-full h-auto object-cover rounded-2xl hover:scale-102 transition-transform duration-500"
                  src={poloImage}
                  alt="Polo PVC Milestones"
                />
              </div>
            </div>

            {/* Content Column */}
            <div className="w-full lg:w-7/12 flex flex-col text-slate-600 text-sm sm:text-base leading-relaxed space-y-5 text-left sm:text-justify">
              <p>
                For nearly two decades, <strong>POLO PVC PVT. LTD.</strong> has been leading the piping industry by delivering innovative, high-performance, and dependable piping solutions under its trusted brand, <strong>LEO®</strong>. Established in 2007, the company has grown into one of West Bengal's most trusted manufacturers, driven by an unwavering commitment to quality, technological advancement, and customer satisfaction
              </p>

              <p>
                Our manufacturing facility on Palitpur Road, Burdwan, uses advanced production technology and rigorous quality control to ensure every product meets high standards of performance, durability, and reliability.
              </p>

              <p>
                Over the years, we have earned the confidence of customers across West Bengal by consistently supplying quality products to Public Health Engineering (PHE), Municipalities, Panchayats, MED, West Bengal Agro Industries Corporation, various Government Departments, and the open market through our extensive network of dealers, distributors, contractors, and institutional customers.
              </p>

              <p>
                Quality is the cornerstone of our business. Our modern manufacturing facility is equipped with advanced technology to produce products that conform to stringent <strong>Bureau of Indian Standards (BIS)</strong> specifications. We are licensed to manufacture:
              </p>

              {/* BIS Accreditation List Box */}
              <div className="bg-orange-50/60 border border-orange-100 rounded-2xl p-5 my-2">
                <ul className="space-y-2 text-slate-800 font-semibold text-xs sm:text-sm text-left">
                  <li className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-orange-500 shrink-0"></span>
                    <span><strong>IS 4985:2021</strong> – uPVC Pipes (40 mm to 315 mm)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-orange-500 shrink-0"></span>
                    <span><strong>IS 4984:2016</strong> – HDPE Pipes (20 mm to 315 mm)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-orange-500 shrink-0"></span>
                    <span><strong>IS 12818:2010</strong> – Blue Casing (Tubewell) Pipes (40 mm to 300 mm)</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-orange-500 shrink-0"></span>
                    <span><strong>IS 10124:2009</strong> – uPVC Fittings</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-orange-500 shrink-0"></span>
                    <span><strong>IS 14182:1994</strong> – Solvent Cement</span>
                  </li>
                </ul>
              </div>

              <p>
                The ISI Certification Mark on our products is a symbol of quality, safety, and reliability, assuring customers that every product complies with rigorous BIS standards and undergoes regular inspections and quality testing.
              </p>

              <p>
                At Polo, our commitment extends beyond manufacturing. We believe in building lasting partnerships by providing dependable technical support, prompt service, timely deliveries, and solutions tailored to our customers' requirements. Continuous improvement, innovation, and customer satisfaction remain at the heart of everything we do.
              </p>

              <p>
                As part of our growth journey, we are expanding our product portfolio to include Water Storage Tanks, CPVC Pipes & Fittings, and uPVC & SWR Drainage Systems, enabling us to offer complete water management and piping solutions under one trusted brand.
              </p>

              <p>
                With nearly two decades of manufacturing excellence, POLO PVC PVT. LTD. continues to stand for quality, integrity, innovation, and customer trust—delivering products that build stronger infrastructure and lasting relationships.
              </p>

              <div className="pt-4 border-t border-slate-100">
                <p className="font-bold text-orange-600 text-base sm:text-lg italic text-center sm:text-left">
                  "Quality You Can Trust. Performance You Can Rely On."
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default History;